const state = {
    user: null
}

const getters = {
    user(state) {
        if (state.user != null) return state.user;
        else {
            let userJson = localStorage.getItem('healthyUser');
            if (userJson != null) {
                state.user = JSON.parse(userJson);
            }
            return state.user
        }
    }
}

const mutations = {
    setUser(state, data) {
        state.user = data;
        if (data != null)
            localStorage.setItem("healthyUser", JSON.stringify(data));
        else
            localStorage.removeItem('healthyUser');
    }
}

const actions = {
    setUser({ commit }, data) {
        commit('setUser', data);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js